/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Sales
 *
 * 1 = Service
 *
 * 2 = General
 *
 * 3 = Technicians
 */
export enum ModuleType {
  Sales = 0,
  Service = 1,
  General = 2,
  Technicians = 3,
}
